import { useEffect, type CSSProperties } from "react";
import { C } from "./MarketplaceShell";

/**
 * The layout constants and style loader the redesigned public site's pages share. Its own module
 * so SiteChrome.tsx exports components only, which is what keeps fast refresh working on it.
 */

/** The page column every section of these pages sits in. */
export const SITE_WRAP: CSSProperties = {
  maxWidth: 1320,
  margin: "0 auto",
  boxSizing: "border-box",
  width: "100%",
};

/** The root every page of this site renders into. */
export const SITE_ROOT: CSSProperties = {
  minHeight: "100dvh",
  display: "flex",
  flexDirection: "column",
  fontFamily: "'Figtree',system-ui,sans-serif",
  color: C.ink,
  background: C.ground,
};

const FONTS = [
  "https://fonts.googleapis.com/css2?family=Source+Serif+4:opsz,wght@8..60,400;8..60,500;8..60,600&family=Figtree:wght@400;500;600;700&display=swap",
];

const CHROME_CSS = `
.site-root a{text-decoration:none}
.site-nav a:hover{background:${C.tint};color:${C.deep}}
.site-pill{transition:opacity .15s}
.site-pill:hover{opacity:.88}
.site-burger{display:none}
.site-menu a:hover{background:${C.tint}}
/* On a phone the nav links do not fit beside the logo, so they move into the burger menu, and the
   account buttons with them — the bar keeps the logo and the burger only. */
@media (max-width:760px){
  .site-nav,.site-auth{display:none!important}
  .site-burger{display:grid}
}
@media (min-width:761px){.site-menu{display:none!important}}
`;

/**
 * Loads the fonts and the chrome's hover rules, plus whatever the page itself needs. Injected at
 * mount and removed at unmount — react-helmet-async does not reliably inject <link>/<style> here.
 */
export function useSiteStyles(pageCss: string) {
  useEffect(() => {
    const nodes: HTMLElement[] = FONTS.map((href) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    const styleEl = document.createElement("style");
    styleEl.textContent = CHROME_CSS + pageCss;
    document.head.appendChild(styleEl);
    nodes.push(styleEl);
    return () => nodes.forEach((n) => n.remove());
  }, [pageCss]);
}
